import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex'
import axios from 'axios'
import Qs from 'qs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: {
      title_cont: null,
      taxonomies_id_in: []
      // keywords_count: 0
    },
    indices: [],
    index: {},
    taxonomies: [],
    taxonomies_id_in: [],
    places_id_in: [],
    categories_id_in: [],
    colors_id_in: [],
    types_id_in: [],
    showModal: false,
    noScroll: false,
    loading: false,
    page: 1,
    isActive: false
  },
  getters: {
    query: state => state.query,
    indices: state => state.indices,
    index: state => state.index,
    taxonomies: state => state.taxonomies,
    taxonomies_id_in: state => state.taxonomies_id_in,
    places_id_in: state => state.places_id_in,
    categories_id_in: state => state.categories_id_in,
    colors_id_in: state => state.colors_id_in,
    types_id_in: state => state.types_id_in,
    showModal: state => state.showModal,
    loading: state => state.loading,
    page: state => state.page,
    noScroll: state => state.noScroll,
    isActive: state => state.isActive
  },
  mutations: {
    setIndices(state, payload) {
      if (state.page > 1) {
        state.indices = state.indices.concat(payload)
      } else {
        state.indices = payload
      }
    },
    unsetIndices(state) {
      state.indices = []
    },
    setIndex(state, { index }) {
      state.index = index
    },
    setPlace(state, payload) {
      if (Array.isArray(payload)) {
        state.places_id_in = payload;
      } else {
        state.places_id_in = [];
        state.places_id_in.push(payload)
      }
    },
    setCategory(state, payload) {
      if (Array.isArray(payload)) {
        state.categories_id_in = payload;
      } else {
        const arr = [];
        state.categories_id_in = [];
        state.categories_id_in.push(payload)
      }
    },
    setType(state, payload) {
      if (Array.isArray(payload)) {
        state.types_id_in = payload;
      } else {
        state.types_id_in = [];
        state.types_id_in.push(payload)
      }
    },
    setColor(state, payload) {
      if (Array.isArray(payload)) {
        state.colors_id_in = payload;
      } else {
        state.colors_id_in = [];
        state.colors_id_in.push(payload)
      }
    },
    updateTaxonomies(state, payload) {
      if (Array.isArray(payload)) {
        state.query.taxonomies_id_in = payload.flat();
      } else {
        const arr = [];
        state.query.taxonomies_id_in.push(22)
      }
      state.page = 1;
      state.indices = [];
      state.noScroll = false;
    },
    unsetTaxonomies(state) {
      state.places_id_in = [];
      state.categories_id_in = [];
      state.colors_id_in = [];
      state.types_id_in = [];
    },
    setKeywords(state, payload) {
      state.query.title_cont = payload;
      state.page = 1;
    },
    setTaxonomies(state, payload) {
      state.taxonomies = payload
    },
    toggleModal(state) {
      state.showModal = !state.showModal
      var modal = document.getElementsByClassName('modal-wrapper')[0];
      modal.scrollIntoView(true);
    },
    toggleScroll(state) {
      state.noScroll = !state.noScroll
    },
    stopScroll(state) {
      state.noScroll = true;
    },
    startScroll(state) {
      state.noScroll = false;
    },
    toggleLoading(state) {
      state.loading = !state.loading
    },
    showNext(state, payload) {
      state.page++
    },
    toggleForm(state) {
      state.isActive = !state.isActive
    },
  },
  actions: {
    async fetchIndices({ commit, state }, { page, query }) {
      await axios.get('/design-base/api/v1/indices', {
        params: {
          q: query,
          page: page
        },
        withCredentials: true,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        paramsSerializer: function (params) {
          return Qs.stringify(params, { arrayFormat: 'brackets' })
        }
      }).then(response => {
        commit('setIndices', response.data.indices)
        if (response.data.indices.length == 24) {
          commit('startScroll')
        } else {
          commit('stopScroll')
        }
      })
        .catch((error) => {
          console.log(error)
        });
    },
    async fetchIndex({ commit }, id) {
      await axios.get(
        `/design-base/api/v1/indices/${id}`, {
        withCredentials: true,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(response => {
        commit('setIndex', { index: response.data.indices })
      }).catch(response => {
        console.log(response)
      })
    },
    async fetchTaxonomies({ commit, state }) {
      await axios.get(
        '/design-base/api/v1/taxonomies',
        {
          withCredentials: true,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(response => {
          commit('setTaxonomies', response.data)
        }).catch(response => {
          console.log(response)
        })
    }
  }
})